import DevicesPage from './devicesPage';

export default DevicesPage;
